import { useNavigate } from "react-router-dom";
import { IcChevron } from "./icons";

/**
 * Back to wherever you actually came from.
 *
 * Every screen used a hardcoded `<Link to="/people">` labelled "חזרה לאנשים",
 * so opening somebody from Dates, from Today or from the Inbox and pressing back
 * dropped you into the people list — a screen you had not been on. Worse, it was
 * a forward navigation, so the browser's own Back button then returned you to
 * the card you had just left.
 *
 * `navigate(-1)` returns to the real previous screen and unwinds the history
 * entry instead of adding one. The fallback covers the case with no history to
 * go back to: a deep link, a refresh, or a tab opened straight onto a card.
 */
export function BackLink({
  fallback = "/people",
  label = "חזרה",
}: {
  fallback?: string;
  label?: string;
}) {
  const navigate = useNavigate();

  return (
    <button
      className="back-link"
      onClick={() => {
        // `idx` is React Router's position in its own history stack. Zero means
        // this is the first entry and there is nothing behind it.
        const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
        if (idx > 0) navigate(-1);
        else navigate(fallback, { replace: true });
      }}
    >
      <IcChevron size={15} /> {label}
    </button>
  );
}
